import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "./../../api/apiCaller";

export const GET_LIST_PACKAGE = "GET_LIST_PACKAGE";
export const GET_LIST_PACKAGE_ERROR = "GET_LIST_PACKAGE_ERROR";
export const GET_LIST_PACKAGE_SUCCESS = "GET_LIST_PACKAGE_SUCCESS";

export const GET_LIST_POSTOFFICE = "GET_LIST_POSTOFFICE";
export const GET_LIST_POSTOFFICE_ERROR = "GET_LIST_POSTOFFICE_ERROR";
export const GET_LIST_POSTOFFICE_SUCCESS = "GET_LIST_POSTOFFICE_SUCCESS";

export const COUNT_LIST_PACKAGE = "COUNT_LIST_PACKAGE";
export const COUNT_LIST_PACKAGE_ERROR = "COUNT_LIST_PACKAGE_ERROR";
export const COUNT_LIST_PACKAGE_SUCCESS = "COUNT_LIST_PACKAGE_SUCCESS";

export const ADD_NEW_PACKAGE = "ADD_NEW_PACKAGE";
export const ADD_NEW_PACKAGE_ERROR = "ADD_NEW_PACKAGE_ERROR";
export const ADD_NEW_PACKAGE_SUCCESS = "ADD_NEW_PACKAGE_SUCCESS";

export const EDIT_A_PACKAGE = "EDIT_A_PACKAGE";
export const EDIT_A_PACKAGE_SUCCESS = "EDIT_A_PACKAGE_SUCCESS";
export const EDIT_A_PACKAGE_ERROR = "EDIT_A_PACKAGE_ERROR";

export const DELETE_A_PACKAGE = "DELETE_A_PACKAGE";
export const DELETE_A_PACKAGE_SUCCESS = "DELETE_A_PACKAGE_SUCCESS";
export const DELETE_A_PACKAGE_ERROR = "DELETE_A_PACKAGE_ERROR";

/**
 * Reducer
 */

const initialState = {
  packages: [],
  postOffice: [],
  error: false,
  count: 0,
  loading: false,
};

export const packagesReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_PACKAGE:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_PACKAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        packages: action.payload,
      };
    case GET_LIST_PACKAGE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    case GET_LIST_POSTOFFICE:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_POSTOFFICE_SUCCESS:
      return {
        ...state,
        loading: false,
        postOffice: action.payload,
      };
    case GET_LIST_POSTOFFICE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    //count list
    case COUNT_LIST_PACKAGE:
      return {
        ...state,
      };
    case COUNT_LIST_PACKAGE_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_LIST_PACKAGE_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //add new
    case ADD_NEW_PACKAGE:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_PACKAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        package: action.payload,
      };
    case ADD_NEW_PACKAGE_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    //edit
    case EDIT_A_PACKAGE:
      return {
        ...state,
        loading: true,
      };
    case EDIT_A_PACKAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        package: action.payload,
      };
    case EDIT_A_PACKAGE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    ///delete
    case DELETE_A_PACKAGE:
      return {
        ...state,
        loading: true,
      };
    case DELETE_A_PACKAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        package: action.payload,
      };
    case DELETE_A_PACKAGE_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListPackage = (order, limit, skip, where) => ({
  type: GET_LIST_PACKAGE,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const getListPostOffice = (order, limit, skip, where) => ({
  type: GET_LIST_POSTOFFICE,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const countListPackage = (where) => ({
  type: COUNT_LIST_PACKAGE,
  data: {
    where,
  },
});

export const addNewPackage = (
  code,
  description,
  poId,
  postmanTel,
  receiverTel,
  deliveryStatus,
  status
) => ({
  type: ADD_NEW_PACKAGE,
  data: {
    code,
    description,
    poId,
    postmanTel,
    receiverTel,
    deliveryStatus,
    status,
  },
});

export const editPackage = (
  id,
  code,
  description,
  poId,
  postmanTel,
  receiverTel,
  deliveryStatus,
  status
) => ({
  type: EDIT_A_PACKAGE,
  data: {
    id,
    code,
    description,
    poId,
    postmanTel,
    receiverTel,
    deliveryStatus,
    status,
  },
});

export const deletePackage = (id) => ({
  type: DELETE_A_PACKAGE,
  data: {
    id,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListPackage,
      countListPackage,
      addNewPackage,
      editPackage,
      deletePackage,
      getListPostOffice,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListPackageApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/vnpost/package", { order, limit, skip, ...where });
};

const getListPostOfficeApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/vnpost/post-office", {
    order,
    limit,
    skip,
    ...where,
  });
};

const countListPackageApi = (where) => {
  return apiCaller.getLogs("/vnpost/package/count", { ...where });
};
const addNewPackageApi = (
  code,
  description,
  poId,
  postmanTel,
  receiverTel,
  deliveryStatus,
  status
) => {
  return apiCaller.post("/vnpost/package", {
    code,
    description,
    poId,
    postmanTel,
    receiverTel,
    deliveryStatus,
    status,
  });
};
const editPackageApi = (
  id,
  code,
  description,
  poId,
  postmanTel,
  receiverTel,
  deliveryStatus,
  status
) => {
  return apiCaller.put(`/vnpost/package/${id}`, {
    code,
    description,
    poId,
    postmanTel,
    receiverTel,
    deliveryStatus,
    status,
  });
};
const deletePackageApi = (id) => {
  return apiCaller.del(`/vnpost/package/${id}`);
};

/**
 * sagas
 */

export const getListPackageFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_PACKAGE);
    try {
      const res = yield call(
        getListPackageApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({ type: GET_LIST_PACKAGE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_LIST_PACKAGE_ERROR, error });
    }
  }
};

export const getListPostOfficeFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_POSTOFFICE);
    try {
      const res = yield call(
        getListPostOfficeApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({ type: GET_LIST_POSTOFFICE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_LIST_POSTOFFICE_ERROR, error });
    }
  }
};

export const countPackageFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_PACKAGE);
    try {
      const res = yield call(countListPackageApi, action.data.where);
      yield put({ type: COUNT_LIST_PACKAGE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: COUNT_LIST_PACKAGE_ERROR, error });
    }
  }
};

export const addNewPackageFlow = function* () {
  while (true) {
    const {
      data: {
        code,
        description,
        poId,
        postmanTel,
        receiverTel,
        deliveryStatus,
        status,
      },
    } = yield take(ADD_NEW_PACKAGE);
    try {
      const res = yield call(
        addNewPackageApi,
        code,
        description,
        poId,
        postmanTel,
        receiverTel,
        deliveryStatus,
        status
      );
      yield put({ type: ADD_NEW_PACKAGE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: ADD_NEW_PACKAGE_ERROR, error });
    }
  }
};

export const editPackageFlow = function* () {
  while (true) {
    const {
      data: {
        id,
        code,
        description,
        poId,
        postmanTel,
        receiverTel,
        deliveryStatus,
        status,
      },
    } = yield take(EDIT_A_PACKAGE);
    try {
      const res = yield call(
        editPackageApi,
        id,
        code,
        description,
        poId,
        postmanTel,
        receiverTel,
        deliveryStatus,
        status
      );
      yield put({ type: EDIT_A_PACKAGE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: EDIT_A_PACKAGE_ERROR, error });
    }
  }
};

export const deletePackageFlow = function* () {
  while (true) {
    const action = yield take(DELETE_A_PACKAGE);
    try {
      const res = yield call(deletePackageApi, action.data.id);
      yield put({ type: DELETE_A_PACKAGE_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: DELETE_A_PACKAGE_ERROR, error });
    }
  }
};
